interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl'
  showIcon?: boolean
  iconOnly?: boolean
}

export default function Logo({ size = 'md', showIcon = true, iconOnly = false }: LogoProps) {
  const sizeClasses = {
    sm: 'text-xl',
    md: 'text-2xl',
    lg: 'text-4xl',
    xl: 'text-5xl',
  }

  const iconSizes = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-14 h-14',
    xl: 'w-20 h-20',
  }

  return (
    <div className="flex items-center gap-3">
      {showIcon && (
        <div className={`${iconSizes[size]} relative flex-shrink-0`}>
          {/* Shield with Radar Icon - matches RugScan logo */}
          <svg
            viewBox="0 0 200 240"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-full h-full"
          >
            {/* Shield shape */}
            <path
              d="M100 10 L180 50 L180 130 C180 170 145 210 100 230 C55 210 20 170 20 130 L20 50 L100 10Z"
              fill="#0F172A"
              className="drop-shadow-lg"
            />

            {/* Outer radar circle */}
            <circle
              cx="100"
              cy="110"
              r="55"
              stroke="#2DD4BF"
              strokeWidth="4"
              fill="none"
            />

            {/* Inner radar circle */}
            <circle
              cx="100"
              cy="110"
              r="35"
              stroke="#2DD4BF"
              strokeWidth="4"
              fill="none"
            />

            {/* Radar sweep line */}
            <path
              d="M100 110 L100 55"
              stroke="#2DD4BF"
              strokeWidth="4"
              strokeLinecap="round"
            />

            {/* Center dot */}
            <circle
              cx="100"
              cy="110"
              r="8"
              fill="#2DD4BF"
            />

            {/* Radar blip / target indicator */}
            <path
              d="M100 110 L130 80"
              stroke="#2DD4BF"
              strokeWidth="4"
              strokeLinecap="round"
            />
            <circle
              cx="130"
              cy="80"
              r="6"
              fill="#2DD4BF"
            />
          </svg>
        </div>
      )}
      {!iconOnly && (
        <span
          className={`${sizeClasses[size]} font-bold tracking-tight`}
        >
          <span className="text-white">Rug</span>
          <span className="text-primary">Scan</span>
        </span>
      )}
    </div>
  )
}
